import { chatMessageFragment } from '../fragments';
import { makeRequest } from '../utils';

/**
 * @param {Record} data
 * @param {string} data.chatId
 * @param {'MESSAGE' | 'LOCATION_REQUEST' | 'SERVICE_REQUEST'} data.type
 * @param {string?} data.text
 * @param {Array<{ name: string, data: string }>} data.attachments
 */
export const sendChatMessage = data =>
  makeRequest({
    operationName: 'SendChatMessage',
    query: `
      mutation SendChatMessage($data: ChatMessageSendInput!) {
        sendChatMessage(data: $data) {
          ...ChatMessageFragment
        }
      }
      
      ${chatMessageFragment}
    `,
    variables: { data },
  });

/**
 * @param {Record} data
 * @param {'MESSAGE' | 'LOCATION_REQUEST' | 'SERVICE_REQUEST'} data.type
 * @param {string?} data.text
 */
export const broadcastChatMessage = data =>
  makeRequest({
    operationName: 'BroadcastChatMessage',
    query: `
      mutation BroadcastChatMessage($data: ChatMessageBroadcastInput!) {
        broadcastChatMessage(data: $data)
      }
    `,
    variables: { data },
  });

/**
 * @param {string} chatId
 * @param {string} messageId
 */
export const markChatMessageAsRead = (chatId, messageId) =>
  makeRequest({
    operationName: 'MarkChatMessageAsRead',
    query: `
      mutation MarkChatMessageAsRead($chatId: String!, $messageId: String!) {
        markChatMessageAsRead(chatId: $chatId, messageId: $messageId)
      }
    `,
    variables: { chatId, messageId },
  });

/**
 * @param {string} messageId
 * @param {string?} data.text
 * @param {boolean?} data.needEdit
 * @param {boolean?} data.needDelete
 */
export const updateChatMessage = (id, data) =>
  makeRequest({
    operationName: 'UpdateChatMessage',
    query: `
      mutation UpdateChatMessage($id: String!, $data: ChatMessageUpdateInput!) {
        updateChatMessage(id: $id, data: $data) {
          ...ChatMessageFragment
        }
      }

      ${chatMessageFragment}
    `,
    variables: { id, data },
  });
